import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import Layout from "./components/layout";
import StudentLayout from "./components/student-layout";
import CreatePreLesson from "./pages/create-pre-lesson";
import EditPreLesson from "./pages/edit-pre-lesson";
import PreLessonOverview from "./pages/pre-lesson-overview";
import StudentRegistration from "./pages/student-registration";
import StudentActivity from "./pages/student-activity";
import Landing from "./pages/landing";
import Home from "./pages/home";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Home />} />
          <Route path="/create-pre-lesson" element={<CreatePreLesson />} />
          <Route path="/edit-pre-lesson/:id" element={<EditPreLesson />} />
          <Route path="/teacher/:code" element={<PreLessonOverview />} />
        </Route>
        <Route path="/student/:code" element={<StudentLayout />}>
          <Route index element={<StudentRegistration />} />
          <Route path=":submissionId" element={<StudentActivity />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
